var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOverviewLoyaltyProgram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m13.16 17.43 3.36-3.5c.17-.15.29-.33.36-.54.07-.21.11-.43.11-.65 0-.46-.17-.9-.49-1.22-.31-.33-.73-.51-1.18-.5-.39 0-.77.11-1.1.31-.43.28-.8.64-1.06 1.08-.27-.43-.63-.79-1.05-1.06-.34-.2-.72-.31-1.11-.32-.45 0-.87.17-1.18.5-.32.32-.5.77-.49 1.22 0 .22.04.44.11.65.07.2.18.39.33.54l3.38 3.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.71 12.26 11.66 2.24a.804.804 0 0 0-.3-.19.96.96 0 0 0-.33-.06H2.85c-.47 0-.85.39-.85.86v8.16c0 .11.02.23.07.33.05.12.12.23.21.33l10.08 10.05.08.08c.34.29.85.26 1.14-.08l8.16-8.16c.18-.16.28-.39.26-.62-.01-.25-.11-.5-.29-.68ZM13 21.14 2.86 11.01V2.85h8.16l10.13 10.13-8.16 8.16Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.69 6.68c.27 0 .53-.11.71-.31.19-.19.29-.45.29-.72 0-.26-.1-.5-.29-.68-.39-.39-1.02-.39-1.42 0-.19.18-.29.42-.29.68 0 .27.1.53.29.72.18.2.44.31.71.31Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverviewLoyaltyProgram);
export default __webpack_public_path__ + "static/media/Overview - Loyalty Program.705952ca47d0664df4f32d730b3aa042.svg";
export { ForwardRef as ReactComponent };